<template>
  <v-container
    fluid
    grid-list-md
    v-if="
      selectedPlan !== null &&
      selectedPlan !== undefined &&
      planOptions !== null &&
      planOptions !== undefined
    "
  >
    <material-card
    :title="$t('globals.payments')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="payments"
    >
      <template v-slot:actions>
        <div style="margin-right: 20px">
          <no-autocomplete-textfield
            clearable
            v-model="searchValue"
            :label="
              planOptions.HasStores && !planOptions.TrackPerEmployer
                ? $t('views.payments.search_locations')
                : $t('components.employers.search_employers_form.title')
            "
            append-icon="search"
          />
        </div>
      </template>
      <v-card-text>
        <v-container fill-height fluid>
          <v-row justify="center">
            {{ $t("views.balanceview.pager_{0}_{1}", [currentPage, totalPages]) }}
          </v-row>
          <v-pagination
            v-model="currentPage"
            :length="totalPages"
            @input="next"
            v-show="false"
            :total-visible="1"
          ></v-pagination>
          <v-row justify="center">
            <v-btn
              @click="next(currentPage - 1)"
              text
              :disabled="currentPage === 1"
            >
              <v-icon>chevron_left</v-icon>
            </v-btn>
            <span style="margin-top: 8px">
              {{ translate2(pagerItem, "Name") }}
            </span>
            <v-btn
              @click="next(currentPage + 1)"
              text
              :disabled="currentPage === totalPages"
            >
              <v-icon>chevron_right</v-icon>
            </v-btn>
          </v-row>
          <v-row>
            <v-col cols="12">
              <store-payments-table
                v-if="planOptions.HasStores && !planOptions.TrackPerEmployer"
                :store="pagerItem"
              />
              <employer-payments-table :employer="pagerItem" v-else />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </material-card>
    <error-handler :error="error"></error-handler>
    <!-- <v-dialog scrollable v-model="loading" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog> -->
    <material-card
      :title="$t('views.paymentsview.plan_expenses')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="money"
    >
      <v-card-text>
        <plan-expenses-table />
      </v-card-text>
    </material-card>
    <material-card
      :title="$t('views.adminfeesview.title')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="receipt"
    >
      <v-card-text>
        <v-row justify="center">
          <v-col cols="12" sm="4">
            {{ $t("views.adminfeesview.totaladminfees") }}
            <br />
            <span class="minfo">
              {{ formatCurrency(totalAdminFee) }}
            </span>
          </v-col>
        </v-row>
        <admin-fees-table />
      </v-card-text>
    </material-card>
  </v-container>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { planSetter } from "../mixins/planSetter";
import { ODataProvider, SortDirection } from "pbas-vue-components";
import ContributionsControlEmployersHeaders from "../headers/ContributionsControlEmployers";
import ContributionsControlStoresHeaders from "../headers/ContributionsControlStores";
import ErrorHandler from "../components/ErrorHandler.vue";
import { translate2 } from "../trans2";
import EmployerPaymentsTable from "../components/BalancePayments/EmployerPaymentsTable.vue";
import StorePaymentsTable from "../components/BalancePayments/StorePaymentsTable.vue";
import PlanExpensesTable from "../components/BalancePayments/PlanExpensesTable.vue";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield.vue";
import AdminFeesTable from "../components/BalancePayments/AdminFeesTable.vue";

export default {
  data() {
    return {
      pagerItem: null,
      error: null,
      pagerProvider: undefined,
      // loading: false,
      currentPage: 0,
      itemsPerPage: 1,
      pagerFetchResult: {
        count: 0,
      },
      pagerHeaders: [],
      searchValue: undefined,
      searchMonitor: null,
      sortHeader: null,
      totalAdminFee: null,
    };
  },
  mixins: [planSetter],
  components: {
    ErrorHandler,
    EmployerPaymentsTable,
    StorePaymentsTable,
    PlanExpensesTable,
    NoAutocompleteTextfield,
    AdminFeesTable,
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["planOptions"]),
    totalPages() {
      return Math.floor(this.pagerFetchResult.count / this.itemsPerPage);
    },
  },
  mounted() {
    if (
      this.selectedPlan !== null &&
      this.selectedPlan !== undefined &&
      this.planOptions !== null &&
      this.planOptions !== undefined
    ) {
      this.loadPlanData();
    }
  },
  watch: {
    selectedPlan: {
      handler() {
        if (this.planOptions) {
          this.loadPlanData();
        }
      },
    },
    planOptions: {
      handler() {
        if (this.selectedPlan) {
          this.loadPlanData();
        }
      },
    },
    searchValue: {
      async handler(v) {
        if (v === null) {
          this.searchValue = undefined;
        }
        if (this.pagerProvider === null || this.pagerProvider === undefined) {
          return;
        }
        const obj = {};
        this.searchMonitor = obj;
        await this.delay(800);
        if (this.searchMonitor !== obj) {
          return;
        }
        this.currentPage = 1;
        console.log("search call getPagerItemsAsync");
        this.getPagerItemsAsync();
      },
    },
  },
  methods: {
    ...mapActions("plansMembers", ["getTotalAdminFee"]),
    translate2(item, property) {
      return translate2(item, property);
    },
    async loadPlanData() {
      this.totalAdminFee = await this.getTotalAdminFee(this.selectedPlan.Id);
      //this.totalAdminFee = "2315.55";
      if (this.planOptions.HasStores && !this.planOptions.TrackPerEmployer) {
        this.pagerHeaders = ContributionsControlStoresHeaders;
        this.pagerProvider = new ODataProvider(
          this.$axiosHttp,
          `plans/${this.selectedPlan.Id}/contributions-control/stores`,
          this.pagerHeaders
        );
      } else {
        this.pagerHeaders = ContributionsControlEmployersHeaders;
        this.pagerProvider = new ODataProvider(
          this.$axiosHttp,
          `plans/${this.selectedPlan.Id}/contributions-control/employers`,
          this.pagerHeaders
        );
      }
      this.sortHeader = this.pagerHeaders.filter(
        (o) => o.title === "globals.name"
      )[0];
      this.currentPage = 1;
      console.log("loadPlanData call getPagerItemsAsync");
      this.getPagerItemsAsync();
    },
    formatCurrency(v) {
      let a = parseFloat(v);
      if (isNaN(a)) return "";
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
      });
      return formatter.format(v);
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    next(page) {
      console.log(page);
      this.currentPage = page;
      console.log("next call getPagerItemsAsync");
      this.getPagerItemsAsync();
    },
    async getPagerItemsAsync() {
      if (this.pagerProvider === undefined || this.pagerProvider === null) {
        return;
      }
      // this.loading = true;
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const count = this.itemsPerPage;
      try {
        this.fetchingPromise = this.pagerProvider.fetchAsync(
          start,
          count,
          [{ header: this.sortHeader, direction: SortDirection.Ascending }],
          this.searchValue
        );
        const localPromise = this.fetchingPromise;

        const result = await localPromise;
        if (localPromise === this.fetchingPromise) {
          this.pagerFetchResult = result;
          this.pagerItem = this.pagerFetchResult.items[0];
        }
        console.log(this.pagerFetchResult);
      } catch (error) {
        // console.log(error)
        // this.pagerFetchResult = {
        //   count: 2,
        //   items: [
        //     {
        //       Translations: [
        //         {
        //           LanguageCode: "en",
        //           Name: "Branch 1",
        //         },
        //         {
        //           LanguageCode: "fr",
        //           Name: "Branch 1 fr",
        //         },
        //       ],
        //       Id: "4828046b-1c05-4a51-b603-593e4ac3c000",
        //       Name: "Branch 1",
        //     },
        //     {
        //       Translations: [
        //         {
        //           LanguageCode: "en",
        //           Name: "Branch 2",
        //         },
        //         {
        //           LanguageCode: "fr",
        //           Name: "Branch 2 fr",
        //         },
        //       ],
        //       Id: "4828046b-1c05-4a51-b603-593e4ac3c001",
        //       Name: "Branch 2",
        //     },
        //   ],
        // };
        this.error = error;
      } finally {
        // this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.minfo {
  font-weight: bold;
  color: #222;
}
</style>